import { useState } from "react";
import { Autocomplete, Box, Card, CardContent, Grid, Typography, styled, TextField, Paper, Button } from "@mui/material";
import { LecsDevice } from "../../../../components/LecsIcon";
import { boxStyle } from "../../../../theme";
import { startToast } from "../../../../utils/notification-loading";

const StyledCard = styled(Card)`
  flex: 1;
  width: auto;
  background-color: #1E1E1E;
  background-image: none;
  border-radius: 15px;
  /* border: 3px solid #449095; */
`;


const StyledText = styled(TextField)`
  & .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: #52a0a6; // Change to your desired focus color
  }
  & .MuiInputLabel-outlined.Mui-focused {
    color: #52a0a6; // Change to your desired label focus color
  }
`;



export const InfoCard = ({ lecsInfo }) => {
    return (
        
        <Box sx={[boxStyle]} >
                <Grid container spacing={lecsInfo.dns && lecsInfo.gateway ? 5 : 10} >
                    <Grid container size={4} xs sx={{ width: '50%' }}>

                        <Grid container size={12}>
                            <Grid size={6}>
                                <Typography className="keyInfoCardLecsReseller">Serial Number :</Typography>
                            </Grid>
                            <Grid size={6}>
                                <Typography className="valueInfoCardLecsReseller">{lecsInfo.matricola}</Typography>
                            </Grid>
                        </Grid>
                        <Grid container size={12}>
                            <Grid size={6}>
                                <Typography className="keyInfoCardLecsReseller">IP :</Typography>
                            </Grid>
                            <Grid size={6}>
                                {lecsInfo && lecsInfo.ipLecs && lecsInfo.ipLecs.length !== 0 && typeof lecsInfo.ipLecs === 'object' ? lecsInfo.ipLecs.map(ip => {

                                    return (
                                        <Typography className="valueInfoCardLecsReseller">{ip}</Typography>
                                    )
                                }) : <Typography className="valueInfoCardLecsReseller">{lecsInfo.ipLecs}</Typography>}
                            </Grid>
                        </Grid>
                        { lecsInfo.dns &&
                        <Grid container size={12}>
                            <Grid size={6}>
                                <Typography className="keyInfoCardLecsReseller">DNS:</Typography>
                            </Grid>
                            <Grid size={6}>
                                <Typography className="keyInfoCardLecsReseller">{lecsInfo.dns}</Typography>
                            </Grid>
                        </Grid>
                        }{ lecsInfo.gateway &&
                        <Grid container size={12}>
                            <Grid size={6}>
                                <Typography className="keyInfoCardLecsReseller">Gateway:</Typography>
                            </Grid>
                            <Grid size={6}>
                                <Typography className="keyInfoCardLecsReseller">{lecsInfo.gateway}</Typography>
                            </Grid>
                        </Grid>
                        }
                        <Grid container size={12}>
                            <Grid size={6}>
                                <Typography className="keyInfoCardLecsReseller">State:</Typography>
                            </Grid>
                            <Grid size={6}>
                                <Typography sx={{ color: (lecsInfo.state === 'Online' ? 'green' : 'red') }} className="valueInfoCardLecsReseller">{lecsInfo.state}</Typography>
                            </Grid>
                        </Grid>
                        
                    </Grid>

                    <Grid size={1} xs="auto">
                        <LecsDevice tipo={lecsInfo.tipo} width={290} />
                    </Grid>

                    <Grid container alignItems="center" spacing={2}>
                        <Grid >
                            <Typography className="keyInfoCardLecsReseller" sx={{ marginRight: 0 }}>
                            Updated:
                            </Typography>
                        </Grid>
                        <Grid >
                            <Typography
                            className="valueInfoCardLecsReseller"
                            sx={{
                                color: (() => {
                                let d = new Date();
                                let lastUpdate = new Date(lecsInfo.lastUpdate);
                                let diffInMs = d - lastUpdate;
                                let diffInHours = diffInMs / (1000 * 60 * 60);
                                return diffInHours < 24 ? 'green' : 'orange';
                                })(),
                                marginLeft: 0,
                            }}
                            >
                            {(() => {
                                let d = new Date();
                                let lastUpdate = new Date(lecsInfo.lastUpdate);
                                let diffInMs = d - lastUpdate;
                                let diffInHours = diffInMs / (1000 * 60 * 60);
                                if (diffInHours < 24) {
                                return lastUpdate.toLocaleString();
                                } else {
                                return `The update could not be made ( LAST UPDATE: ${lastUpdate.toLocaleString()} )`;
                                }
                            })()}
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>

                </Box>
    )
}

export const ChangeIPCard = ({ tipo }) => {
    const [interfaceNet, setInterfaceNet] = useState("")
    const [interfaceNetValue, setInterfaceNetValue] = useState('')
    const [ipAddress, setIpAddress] = useState('')
    const [gateway, setGateway] = useState('')
    const [dns, setDNS] = useState('')
    const AvalaibleInterfaceNet = tipo === 'LECS+64' ? ['LAN0', 'LAN1'] : tipo === 'LECS-64' ? ['LAN0', 'LAN1'] : tipo === 'LECS-CORE-4' ? ['LAN1', 'LAN2', 'LAN3', 'LAN4'] : tipo === 'LECS-CORE-2' ? ['LAN1', 'LAN2'] : []
    const [errorIpAddress, setErrorIpAddress] = useState(false)
    const [errorGateway, setErrorGateway] = useState(false)
    const [errorDNS, setErrorDNS] = useState(false)

    function validateIPwithSubnetMask(ip) {
        const regexp = /^(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)\/([0-9]|[1-2][0-9]|3[0-2])$/;
        return regexp.test(ip);
    }
    function validateIP(ip) {
        const regexp = /^(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)$/;
        return regexp.test(ip);

    }

    const handelChangeIpAddress = (e) => {
        const { value } = e.target
        setIpAddress(value)
        if (validateIPwithSubnetMask(value)) {
            setErrorIpAddress(false)
        } else {
            setErrorIpAddress(true)
        }
    }
    const handelChangeGateway = (e) => {
        const { value } = e.target
        setGateway(value)
        if (validateIP(value)) {
            setErrorGateway(false)
        } else {
            setErrorGateway(true)
        }
    }
    const handleChangeDNS = (e) => {
        const { value } = e.target
        setDNS(value)
        if (validateIP(value)) {
            setErrorDNS(false)
        } else {
            setErrorDNS(true)
        }
    }

    const ForChangeLECSIP = (e) => {
        startToast();
        /* const payload = {
            "action": "add",
            "ip": ipAddress,
            "gateway": gateway,
            "dns": dns,
            "tipo": tipo,
            "interface": interfaceNet
        }
        API.ResellerChangeIP(payload).then(res => {
            setIpAddress('')
            setGateway('')
            setDNS('')
            setInterfaceNet('')
            updateToastSuccess("LECS ip has been changed correctly, wait for LECS to restart and refresh the page to verify the change");
        }).catch(err => {
            console.error('[ForChangeLECSIP] error:', err);
            updateToastError(err.response.data.error);
        }) */
    }

    const ToResetDHCP = (e) => {
        startToast();
        /* const payload = {
            "action": "reset",
        }
        API.ResellerChangeIP(payload).then(res => {
            setIpAddress('')
            setGateway('')
            setDNS('')
            setInterfaceNet('')
            updateToastSuccess("LECS ip has been changed correctly, wait for LECS to restart and refresh the page to verify the change");
        }).catch(err => {
            console.error('[ToResetDHCP] error:', err);
            updateToastError(err.response.data.error);
        }) */
    }



    return (
        <StyledCard>
            <CardContent>
                <Grid container spacing={2}>
                    <Grid size={12}><Typography sx={{ fontSize: 18, fontWeight: 900 }}>Change LECS IP Section</Typography></Grid>
                    <Grid size={6}>
                        <Autocomplete
                            id="interfaceNet-autocomplete"
                            options={AvalaibleInterfaceNet}
                            value={interfaceNet}
                            onChange={(event, newValue) => {
                                setInterfaceNet(newValue);
                            }}
                            inputValue={interfaceNetValue}
                            onInputChange={(event, newInputValue) => {
                                setInterfaceNetValue(newInputValue);
                            }}
                            renderInput={(params) => (
                                <StyledText
                                    {...params}
                                    label="LECS's Network Interface"
                                    variant="outlined"
                                    fullWidth
                                />
                            )}
                            sx={{ mb: 2 }}
                            PaperComponent={({ children }) => (
                                <Paper style={{ backgroundColor: "#2a2a2a" }} elevation={5}>
                                    {children}
                                </Paper>
                            )}
                        />
                        <StyledText label='New IP (with the subnet mask) of LECS' fullWidth value={ipAddress} onChange={handelChangeIpAddress} error={errorIpAddress} helperText={errorIpAddress ? "Enter a valid IP address with CIDR (e.g., 192.168.7.1/24)" : ""} />
                    </Grid>
                    <Grid size={6}>
                        <StyledText sx={{ mb: 2 }} label='New Gateway for LECS' fullWidth value={gateway} onChange={handelChangeGateway} error={errorGateway} helperText={errorGateway ? "Enter a valid IP address (e.g., 192.168.1.1)" : ""} />
                        <StyledText label='New DNS for LECS' fullWidth value={dns} onChange={handleChangeDNS} error={errorDNS} helperText={errorDNS ? "Enter a valid IP address (e.g., 8.8.8.8)" : ""} />
                    </Grid>
                    <Grid size={12}>
                        <Button
                            disabled={errorDNS || errorGateway || errorIpAddress || dns.length === 0 || interfaceNet.length === 0 || ipAddress.length === 0 || gateway.length === 0}
                            variant="contained"
                            fullWidth
                            onClick={ForChangeLECSIP}
                            sx={{
                                backgroundColor: "#2d2d2d !important",
                                mt: 3,
                                mb: 2,
                                "&:hover": {
                                    backgroundColor: "#eaeaea !important",
                                    color: "#131C2D",
                                },
                            }}
                            style={{ fontWeight: "bold" }}
                        >
                            CHANGE LECS IP
                        </Button>
                        <Button
                            variant="contained"
                            fullWidth
                            onClick={ToResetDHCP}
                            sx={{
                                backgroundColor: "#2d2d2d !important",
                                mt: 3,
                                mb: 2,
                                "&:hover": {
                                    backgroundColor: "#eaeaea !important",
                                    color: "#131C2D",
                                },
                            }}
                            style={{ fontWeight: "bold" }}
                        >
                            RESET DHCP ON LECS
                        </Button>
                    </Grid>
                </Grid>

            </CardContent>
        </StyledCard>
    )
}